import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { essayStructureData, getDataForDifficulty } from './data/skills/writing/essayStructure';

export default function EssayStructure() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : essayStructureData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
